module.exports = __webpack_public_path__ + "r-v3/img/minus.2d2082c2.svg";